import { useCallback, useState } from "react";
import { ExecucaoOrcamentariaParams } from "core/features/execucao-orcamentaria/typings/index";

export const defaultFiltroExecucaoOrcamentaria = {
  search: "",
  orderBy: "dataInicio",
  orderDirection: "DESC",
};

function useFiltroExecucaoOrcamentaria() {
  const [filtro, setFiltro] = useState<ExecucaoOrcamentariaParams>(
    defaultFiltroExecucaoOrcamentaria
  );

  const onChangeFiltro = useCallback(
    (newValues: Partial<ExecucaoOrcamentariaParams>) => {
      setFiltro((prev: any) => ({ ...prev, ...newValues }));
    },
    []
  );

  const onResetFiltro = useCallback(() => {
    setFiltro(defaultFiltroExecucaoOrcamentaria);
  }, []);

  return {
    filtro,
    setFiltro,
    onChangeFiltro,
    onResetFiltro,
  };
}

export default useFiltroExecucaoOrcamentaria;
